<template>

    <div v-if="data" :class="[{'proportional':  settings.isProportional }, 'contentWrapper previewContainer']" v-bind:style="{ width: settings.width+'%' }">

        <div class="prop-wrap">

            <div :class="[{'bordered':  settings.isBordered }, 'prop-inner']">

                <!-- Placement Code -->
                <div class="placementCode" v-if="contentElementData[1].product && contentElementData[1].product.placementCode">
                    {{ contentElementData[1].product.placementCode }}
                </div>

                <span class="type" v-if="contentElementData[0] && contentElementData[0].value">{{ contentElementData[0].value }}</span>

                <!-- Header -->
                <div class="contentHeader">
                    <h1 class="title" v-if="contentElementData[1] && contentElementData[1].product != null" v-html="contentElementData[1].product.productAdviceTitle"></h1>
                </div>

                <!-- BODY -->
                <div class="contentBody" v-if="contentElementData[1] && contentElementData[1].product != null" v-html="contentElementData[1].product.productAdviceText">
                    <!-- {{ contentElementData[1].product.productAdviceText }} -->
                </div>

                <!-- FOOTER -->
                <div class="contentFooter">

                    <h2 class="subtitle" v-if="contentElementData[1] && contentElementData[1].product != null" v-html="contentElementData[1].product.displayName"></h2>

                    <!-- Störer -->
                    <!--
                    <div class="stoerer" v-if="hasCoupon && activeUser.userRole.name != 'Industriepartner'">
                        <div class="stoererText">- {{ stoererText }} €</div>
                    </div>
                    -->     

                    <div class="imgWrapper lazy-img-fadein has-text-centered" v-lazy:background-image="getAsset" v-if="contentElementData[1] && contentElementData[1].product && contentElementData[1].product.productAssets.length > 0 && contentElementData[1].product.productAssets[0].asset != ''">
                    </div>

                    <div class="productType" v-if="productType">
                        <span></span>
                        {{ $t('PRODUCT_TYPE-' + productType) }}
                    </div>

                    <!-- DISCLAIMER -->
                    <div class="disclaimer">

                        <template v-if="productType == 'MEDICAL_PRODUCT'">
                            <lang :labelKey="productTypes.MEDICAL_PRODUCT.data.label"></lang>
                        </template>

                        <template v-else-if="productType == 'MEDICINAL_PRODUCT'">
                            <lang :labelKey="productTypes.MEDICINAL_PRODUCT.data.label"></lang>
                        </template>

                        <template v-else-if="productType == 'HOMEOPATHIC_MEDICINAL_PRODUCT'">
                            <lang :labelKey="productTypes.HOMEOPATHIC_MEDICINAL_PRODUCT.data.label"></lang>
                        </template>

                        <template v-else-if="productType == 'TRADITIONAL_HERBAL_MEDICINAL_PRODUCT'">
                            <lang :labelKey="productTypes.TRADITIONAL_HERBAL_MEDICINAL_PRODUCT.data.label"></lang>
                        </template>

                    </div>

                </div>

            </div>

        </div>

    </div>

</template>


<script>

export default {

    props: ['data', 'settings'],

    data(){
		return {
            contentElementData: null,
            stoererText: 0
		}
	},

    created() {

        this.contentElementData = this.data;

        $('.contentWrapper').flowtype({
            minFont : 2,
            fontRatio: 20
        });

    },

    mounted() {

        $('.contentWrapper').flowtype({
            minFont : 2,
            fontRatio: 20
        });

   },

    updated() {

        // react to updates
        this.contentElementData = this.data;

        $('.contentWrapper').flowtype({
            minFont : 2,
            fontRatio: 20
        });

    },


    computed: {

        productTypes() {
            return this.$store.getters.getTermsByTaxonomy('PRODUCT_TYPES');
        },

        productAssetTypes() {
			return this.$store.getters.getTermsByTaxonomy('PRODUCT_ASSET_TYPES');
		},

        productType() {

            if(!this.contentElementData[1] || !this.contentElementData[1].product) {
                return false;
            }

            for(var key in this.productTypes) {
                if(this.productTypes[key].id == this.contentElementData[1].product.type) {
                    return this.productTypes[key].name;
                }
            }

        },


        hasCoupon() {

            if(!this.contentElementData[1] || this.contentElementData[1].product == null) {
                return false;
            }


            if(this.contentElementData[1].product.productVariants.length > 0)
            {
                for(var i=0; i < this.contentElementData[1].product.productVariants.length; i++)
                {
                    if(this.contentElementData[1].product.productVariants[i].voucher != null && this.contentElementData[1].product.productVariants[i].voucher.discount != null) {

                        if(this.contentElementData[1].product.productVariants[i].voucher.discount != parseInt(this.contentElementData[1].product.productVariants[i].voucher.discount)) {
                            this.stoererText = this.contentElementData[1].product.productVariants[i].voucher.discount.toString().replace(".", ",");
                        } else {
                            this.stoererText = parseInt(this.contentElementData[1].product.productVariants[i].voucher.discount);
                        }

                        return true;

                    }
                }
            }

            // check for special Coupons
            if(this.contentElementData[1].product.productVouchers.length > 0 && this.contentElementData[1].product.productVouchers != null && this.contentElementData[1].product.productVouchers.length > 0 && this.contentElementData[1].product.productVouchers[0].productVoucherProductVariants.length > 0) {

                if(this.contentElementData[1].product.productVouchers[0].discount != parseInt(this.contentElementData[1].product.productVouchers[0].discount)) {
                    this.stoererText = this.contentElementData[1].product.productVouchers[0].discount.toString().replace(".", ",");
                } else {
                    this.stoererText = parseInt(this.contentElementData[1].product.productVouchers[0].discount);
                }


                return true;
            }

            return false;


            /* OG
            if(this.contentElementData[1] && this.contentElementData[1].product != null && this.contentElementData[1].product.productVariants.length > 0)
            {
                for(var i=0; i < this.contentElementData[1].product.productVariants.length; i++)
                {
                    if(this.contentElementData[1].product.productVariants[i].voucher != null && this.contentElementData[1].product.productVariants[i].voucher.discount != null) {

                        if(this.contentElementData[1].product.productVariants[i].voucher.discount != parseInt(this.contentElementData[1].product.productVariants[i].voucher.discount)) {
                            this.stoererText = this.contentElementData[1].product.productVariants[i].voucher.discount.toString().replace(".", ",");
                        } else {
                            this.stoererText = parseInt(this.contentElementData[1].product.productVariants[i].voucher.discount);
                        }

                        return true;

                    }
                }
            }
            */

        },

        getAsset() {

            var foundCoupons = [];
            var foundDefaults = [];

            if(this.contentElementData[1].product.productAssets.length > 0) {

                // Bei der Coupon-Darstellung bitte das Bild vom Typ „Coupon“ verwenden, oder wenn nicht vorhanden das Bild mit Typ „Default“;
                for(var i = 0; i < this.contentElementData[1].product.productAssets.length; i++) {

                    if(this.contentElementData[1].product.productAssets[i].type == this.productAssetTypes.COUPON.id) {
                        foundCoupons.push(i);
                    }
                    else if(this.contentElementData[1].product.productAssets[i].type == this.productAssetTypes.DEFAULT.id) {
                        foundDefaults.push(i);
                    }
                }

            }

            if(foundDefaults.length > 0) {
                return this.$config.assets + this.contentElementData[1].product.productAssets[foundDefaults[0]].asset.path + "/" + this.contentElementData[1].product.productAssets[foundDefaults[0]].asset.filename;
            }
            if(foundCoupons.length > 0) {
                return this.$config.assets + this.contentElementData[1].product.productAssets[foundCoupons[0]].asset.path + "/" + this.contentElementData[1].product.productAssets[foundCoupons[0]].asset.filename;
            }
            return '';

        },

    },


    methods: {

    }


}

</script>




<style scoped>

    span.type {
        display: block;
        margin: 0 auto;
        font-size: 130%;
        font-weight: 400;
        font-style: italic;
        text-align: center !important;
    }

    /* header */
    .previewContainer .contentHeader {
        z-index: 999;
        margin: 8% 0 4% 0;
        width: 100%;
    }
    .previewContainer .contentHeader h2 {
        font-size: 145%;
        margin: 0;
        padding: 0;
        white-space: normal;
    }
    .previewContainer h1.title {
        white-space: normal !important;
    }
    .previewContainer h2.subtitle {
        font-size: 100%;
        white-space: normal !important;
        margin: 0 !important;
    }

    /* body */
    .previewContainer .contentBody {
        max-height: 60% !important;
        margin: 0 0 5% 0;
        line-height: 125%;
        overflow: hidden;
        white-space: normal;
        font-family: inherit;
    }

    /* footer */
    .previewContainer .contentFooter {
        position: relative;
        margin: 0 !important;
        min-height: 15%;
        overflow: hidden;
    }

    .previewContainer .contentFooter .stoerer {
        position: absolute;
        z-index: 9;
        background: transparent url(../../../assets/img/produktcoupons_wischer_kurz.png) center center no-repeat;
        background-size: contain;
        z-index: 9;
        left: 2%;
        top: 3% !important;
        width: 35%;
        padding-bottom: 35%;
        height: 0;
    }
    .previewContainer .contentFooter .stoererText {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        width: 100%;
        height: 100%;
        font-size: 120%;
        color: #eee;
        -moz-transform: rotate(-19deg);
        -ms-transform: rotate(-19deg);
        -o-transform: rotate(-19deg);
        -webkit-transform: rotate(-19deg);
        transform: rotate(-19deg);
    }

    .previewContainer .contentFooter .imgWrapper {
        position: relative;
        background-repeat: no-repeat !important;
        background-position: 50% 50% !important;
        background-size: contain !important;
        margin: 0 auto !important;
        height: 0;
        padding-bottom: 60%;
        width: 60%;
    }

    .previewContainer .contentFooter .lazy-img-fadein[lazy=loading] {
        background-position: 50% 50% !important;
        background-size: 30% !important;
    }

    .previewContainer .contentFooter h3 {
        font-size: 130%;
        margin: 0 0 2% 0;
        padding: 0;
        white-space: normal;
    }


    .contentFooter .disclaimer {
        margin-top: 2%;
        position: relative;
        font-weight: normal;
        font-size: 45%;
        word-break: normal;
        white-space: normal !important;
        line-height: 1.4em;
    }


</style>
